export default __webpack_public_path__ + "static/media/CHM_logo.d0d38916.png";